import { useContext } from "react"
import { ContextualSidebarContext } from "@context"
import MenuRouter from "@components/Menus/SiteDataMenu/MenuRouter"

function useSiteDataMenu(clientId) {
  const { setContextualSidebar } = useContext(ContextualSidebarContext);

  const open = (view) => {
    setContextualSidebar(prev => ({
      ...prev,
      open: true,
      title: "Site Options",
      subTitle: "Manage your site data and reports.",
      content: <MenuRouter clientId={clientId} initialView={view} />,
      size: "lg",
    }));
  };

  const close = () => {
    setContextualSidebar(prev => ({
      ...prev,
      open: false,
    }));
  };

  return { open, close }
}

export default useSiteDataMenu